import React from "react";
import { Row, Column, FormGroup, Checkbox } from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const BusinessIdeaForm = ({
  disabled,
  candidature,
  selectedBusinessPhases,
  selectedBusinessSectors,
  setSelectedBusinessSectors,
  setSelectedBusinessPhases,
}) => {
  const { data: businessSectors } = useGet("/lookup/business-sectors");
  const { data: businessPhases } = useGet("/lookup/business-idea-phases");

  const updatePhases = (id, checked) => {
    setSelectedBusinessPhases(
      updateCheckedOptions(selectedBusinessPhases, id, checked)
    );
  };

  const updateSectors = (id, checked) => {
    setSelectedBusinessSectors(
      updateCheckedOptions(selectedBusinessSectors, id, checked)
    );
  };

  useEffect(() => {}, [selectedBusinessPhases]);

  return (
    <FormGroup legendText="IDEIA DE NEGÓCIO?" className="section-header">
      {selectedBusinessPhases && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label">
            16.1. Em que área pretende trabalhar?
          </legend>
          <Row>
            <Column sm={12} md={12} lg={12}>
              {businessSectors.map((x) => (
                <DynamicCheckbox
                  key={"bs" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updateSectors}
                  checked={isCandidatureOptionChecked(
                    selectedBusinessPhases,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
      {selectedBusinessPhases && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label">
            16.2. Em que fase está a sua ideia de negócio?
          </legend>
          <Row>
            <Column sm={12} md={12} lg={12}>
              {businessPhases.map((x) => (
                <DynamicCheckbox
                  key={"bp" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updatePhases}
                  checked={isCandidatureOptionChecked(
                    selectedBusinessPhases,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
    </FormGroup>
  );
};

BusinessIdeaForm.defaultProps = {
  disabled: false,
};

export default BusinessIdeaForm;
